<div *ngIf="isReadOnly">
  <ion-item class="read-only-banner ion-text-center" lines="none">
    <ion-label class="ion-text-wrap">
      Your account is currently in READ ONLY MODE due to a billing issue. Please
      contact us to reactivate your account
    </ion-label>
    <ion-button slot="end" fill="outline" color="light" (click)="contact()"
      >Contact us</ion-button
    >
  </ion-item>
</div>
